/**
 * Page résultats pneus (Partie 3) — vanilla JS, zéro dépendance, même esprit que
 * devis-widget.js. Le 1er lot du catalogue (≤250 produits, avec tous les metafields) est déjà
 * embarqué côté serveur par sections/pneus-resultats.liquid dans #pneus-catalogue-data. Si
 * `data-total-pages` (posé par ce même fichier Liquid, plafonné à 250 produits/page par Shopify)
 * indique plus d'une page, les pages suivantes sont récupérées ici via l'API de rendu de section
 * Shopify (fetch ?page=N&section_id=...) avant tout filtrage/affichage — seul cas où ce fichier
 * fait un appel réseau.
 *
 * Unités : `price` (prix du produit Shopify) est en centimes ; `prix_montage` (metafield Money)
 * est une chaîne décimale (ex. "17.95") — ne jamais les additionner sans diviser `price` par 100
 * d'abord.
 *
 * Ajout au panier (bouton "Ajouter") : la page résultats est une page à part, distincte du
 * widget de devis (Partie 2) où vit réellement `state.cart`. Le seul moyen de transmettre l'item
 * choisi jusqu'au widget est un aller-retour par localStorage (clé PNEU_CART_HANDOFF_KEY, cf.
 * devis-widget.js qui la lit une fois au montage puis la vide) — pas de round-trip serveur.
 */
(function () {
  'use strict';

  var PNEU_CART_HANDOFF_KEY = 'mautoPendingPneuCartItem'; // doit rester identique à devis-widget.js
  var SAISONS = ['Été', 'Hiver', '4 saisons', 'Toutes'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function euros(n) {
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  function readCatalogue() {
    var el = document.getElementById('pneus-catalogue-data');
    if (!el) return [];
    try {
      var data = JSON.parse(el.textContent || '[]');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function parseCatalogueFromHtml(html) {
    var match = html.match(/<script[^>]*id="pneus-catalogue-data"[^>]*>([\s\S]*?)<\/script>/);
    if (!match) return [];
    try {
      var data = JSON.parse(match[1]);
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function fetchCataloguePage(pageNumber, sectionId) {
    var sep = window.location.search ? '&' : '?';
    var url = window.location.pathname + window.location.search + sep + 'page=' + pageNumber + '&section_id=' + encodeURIComponent(sectionId);
    return fetch(url)
      .then(function (res) { return res.text(); })
      .then(parseCatalogueFromHtml)
      .catch(function () { return []; }); // page suivante indisponible — on affiche ce qu'on a déjà plutôt que de bloquer
  }

  // Le catalogue peut dépasser la limite Shopify de 250 produits/page (`paginate`) : au-delà de
  // la 1re page déjà embarquée dans le HTML, on va chercher les pages restantes en parallèle.
  function loadFullCatalogue(root, firstPage) {
    var totalPages = parseInt(root.getAttribute('data-total-pages'), 10) || 1;
    var sectionId = root.getAttribute('data-section-id');
    if (totalPages <= 1 || !sectionId) {
      return Promise.resolve(firstPage);
    }
    var pending = [];
    for (var p = 2; p <= totalPages; p++) {
      pending.push(fetchCataloguePage(p, sectionId));
    }
    return Promise.all(pending).then(function (pages) {
      return pages.reduce(function (all, page) { return all.concat(page); }, firstPage.slice());
    });
  }

  function readParams() {
    var p = new URLSearchParams(window.location.search);
    return {
      largeur: p.get('largeur') || '',
      hauteur: p.get('hauteur') || '',
      diametre: p.get('diametre') || '',
      saison: p.get('saison') || '',
      quantite: p.get('quantite') || '4',
    };
  }

  function matchesDimension(p, dims) {
    return String(p.largeur) === String(dims.largeur) &&
      String(p.hauteur) === String(dims.hauteur) &&
      String(p.diametre) === String(dims.diametre);
  }

  function distinctMarques(list) {
    var seen = {};
    var out = [];
    list.forEach(function (p) {
      if (p.marque && !seen[p.marque]) { seen[p.marque] = true; out.push(p.marque); }
    });
    out.sort();
    return out;
  }

  function showToast(item) {
    var existing = document.querySelector('.pneus-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'pneus-toast';
    toast.innerHTML =
      '<span>✅ ' + esc(item.marque) + ' ' + esc(item.modele) + ' ajouté à votre panier de devis</span>' +
      '<button type="button">Voir mon panier</button>';
    document.body.appendChild(toast);
    toast.querySelector('button').addEventListener('click', function () {
      var fab = document.getElementById('mauto-devis-fab');
      if (fab) fab.click();
      toast.remove();
    });
    setTimeout(function () { if (toast.parentNode) toast.remove(); }, 8000);
  }

  function init() {
    var root = document.getElementById('pneus-resultats-root');
    if (!root) return;

    root.innerHTML = '<p class="pneus-resultats-loading">Chargement du catalogue…</p>';
    loadFullCatalogue(root, readCatalogue()).then(function (catalogue) {
      renderCatalogue(root, catalogue);
    });
  }

  function renderCatalogue(root, catalogue) {
    var dims = readParams();
    var hasDims = !!(dims.largeur && dims.hauteur && dims.diametre);

    var usedFallback = false;
    var baseResults = catalogue;
    if (hasDims) {
      var exact = catalogue.filter(function (p) {
        return matchesDimension(p, dims) && (!dims.saison || p.saison === dims.saison);
      });
      if (exact.length) {
        baseResults = exact;
      } else {
        var dimOnly = catalogue.filter(function (p) { return matchesDimension(p, dims); });
        baseResults = dimOnly;
        usedFallback = dimOnly.length > 0;
      }
    }

    // Filtres ajustables par le client, initialisés depuis la dimension demandée — appliqués sur
    // baseResults (qui reste figé sur la dimension d'origine ; changer la saison ici ne relance
    // jamais une recherche sur une autre dimension, cf. lien "Modifier ma recherche").
    var filters = { marques: [], prixMax: null, saison: dims.saison || '' };
    var currentResults = [];

    function applyFilters() {
      var list = (hasDims ? baseResults : catalogue).slice();
      if (filters.saison) list = list.filter(function (p) { return p.saison === filters.saison; });
      if (filters.marques.length) list = list.filter(function (p) { return filters.marques.indexOf(p.marque) !== -1; });
      if (filters.prixMax != null) list = list.filter(function (p) { return (p.price || 0) / 100 <= filters.prixMax; });
      return list;
    }

    function renderCard(p) {
      var prixUnitaire = (p.price || 0) / 100;
      var prixMontage = p.prix_montage ? parseFloat(p.prix_montage) : 0;
      var qteDefault = dims.quantite === '2' ? '2' : '4';
      return (
        '<div class="pneus-card" data-id="' + esc(p.id) + '">' +
          (p.image ? '<img class="pneus-card-image" src="' + esc(p.image) + '" alt="' + esc((p.marque || '') + ' ' + (p.modele || '')) + '" loading="lazy">' : '') +
          '<div class="pneus-card-marque">' + esc(p.marque || '') + '</div>' +
          '<div class="pneus-card-modele">' + esc(p.modele || p.title || '') + '</div>' +
          '<div class="pneus-card-dimension">' + esc(p.largeur) + '/' + esc(p.hauteur) + ' R' + esc(p.diametre) + (p.saison ? ' — ' + esc(p.saison) : '') + '</div>' +
          (p.etiquette_carburant || p.etiquette_adherence || p.etiquette_bruit ?
            '<div class="pneus-card-etiquettes">' +
              (p.etiquette_carburant ? '<span class="pneus-etiquette-badge" title="Consommation carburant">' + esc(p.etiquette_carburant) + '</span>' : '') +
              (p.etiquette_adherence ? '<span class="pneus-etiquette-badge" title="Adhérence sol mouillé">' + esc(p.etiquette_adherence) + '</span>' : '') +
              (p.etiquette_bruit ? '<span class="pneus-etiquette-badge" title="Bruit">' + esc(p.etiquette_bruit) + ' dB</span>' : '') +
            '</div>' : '') +
          '<div class="pneus-card-prix-row">' +
            '<div class="pneus-card-prix">' + euros(prixUnitaire) + ' <span class="pneus-card-prix-unite">/ pneu</span></div>' +
            (prixMontage ? '<div class="pneus-card-montage">+ ' + euros(prixMontage) + ' / unité de montage</div>' : '') +
            (p.disponibilite ? '<div class="pneus-card-disponibilite">' + esc(p.disponibilite) + '</div>' : '') +
          '</div>' +
          '<div class="pneus-card-actions">' +
            '<select class="pneus-card-qte" data-qte-select>' +
              ['2', '4'].map(function (q) { return '<option value="' + q + '"' + (q === qteDefault ? ' selected' : '') + '>' + q + '</option>'; }).join('') +
            '</select>' +
            '<button type="button" class="pneus-card-add" data-action="add">Ajouter</button>' +
          '</div>' +
        '</div>'
      );
    }

    function wireCards() {
      var cards = root.querySelectorAll('.pneus-card');
      for (var i = 0; i < cards.length; i++) {
        (function (card) {
          var id = card.getAttribute('data-id');
          var product = currentResults.filter(function (p) { return String(p.id) === id; })[0];
          if (!product) return;
          card.querySelector('[data-action="add"]').addEventListener('click', function () {
            var qte = card.querySelector('[data-qte-select]').value;
            var item = {
              type: 'pneu_produit',
              productId: product.id,
              productHandle: product.handle,
              marque: product.marque || '',
              modele: product.modele || product.title || '',
              dimension: product.largeur + '/' + product.hauteur + ' R' + product.diametre,
              saison: product.saison || '',
              quantite: qte,
              prixPneuUnitaire: (product.price || 0) / 100,
              prixMontageUnitaire: product.prix_montage ? parseFloat(product.prix_montage) : 0,
              message: '',
            };
            try { localStorage.setItem(PNEU_CART_HANDOFF_KEY, JSON.stringify(item)); } catch (e) { /* localStorage indisponible — ajout silencieusement perdu */ }
            showToast(item);
          });
        })(cards[i]);
      }
    }

    function wireFilters() {
      var checkboxes = root.querySelectorAll('[data-marque]');
      for (var i = 0; i < checkboxes.length; i++) {
        checkboxes[i].addEventListener('change', function (ev) {
          var m = ev.currentTarget.getAttribute('data-marque');
          if (ev.currentTarget.checked) filters.marques.push(m);
          else filters.marques = filters.marques.filter(function (x) { return x !== m; });
          render();
        });
      }
      var prixInput = root.querySelector('#pneus-filter-prix');
      if (prixInput) {
        // "change" (pas "input") : évite de perdre le focus/curseur à chaque frappe, le
        // re-rendu remplace tout root.innerHTML.
        prixInput.addEventListener('change', function () {
          var v = parseFloat(prixInput.value);
          filters.prixMax = isNaN(v) ? null : v;
          render();
        });
      }
      var saisonSelect = root.querySelector('#pneus-filter-saison');
      if (saisonSelect) {
        saisonSelect.addEventListener('change', function () {
          filters.saison = saisonSelect.value;
          render();
        });
      }
    }

    function render() {
      currentResults = applyFilters();
      var marqueOptions = distinctMarques(hasDims ? baseResults : catalogue);
      var html = '';

      if (hasDims) {
        html +=
          '<div class="pneus-resultats-recap">' +
            '<div>' +
              '<div class="pneus-resultats-recap-dimension">' + esc(dims.largeur) + '/' + esc(dims.hauteur) + ' R' + esc(dims.diametre) + (dims.saison ? ' — ' + esc(dims.saison) : '') + '</div>' +
              '<div class="pneus-resultats-recap-note">Dimension recherchée</div>' +
            '</div>' +
            '<a class="pneus-resultats-recap-edit" href="/pages/devis-en-ligne">Modifier ma recherche</a>' +
          '</div>';
      }

      if (usedFallback) {
        html += '<div class="pneus-resultats-fallback-notice">Aucun pneu ' + (dims.saison ? esc(dims.saison) + ' ' : '') + 'exactement en ' + esc(dims.largeur) + '/' + esc(dims.hauteur) + ' R' + esc(dims.diametre) + ' — voici tous les pneus disponibles dans cette dimension, toutes saisons confondues.</div>';
      }

      if (!currentResults.length) {
        html +=
          '<div class="pneus-empty-state">' +
            '<p>Aucun pneu disponible pour cette recherche actuellement — contactez-nous pour un devis personnalisé, nous complétons le catalogue au fur et à mesure.</p>' +
            '<a href="/pages/devis-en-ligne">Demander un devis</a>' +
          '</div>';
        root.innerHTML = html;
        return;
      }

      html +=
        '<div class="pneus-resultats-layout">' +
          '<aside class="pneus-resultats-filters">' +
            '<div class="pneus-filter-group">' +
              '<p class="pneus-filter-title">Marque</p>' +
              marqueOptions.map(function (m) {
                return '<label class="pneus-filter-checkbox"><input type="checkbox" data-marque="' + esc(m) + '"' + (filters.marques.indexOf(m) !== -1 ? ' checked' : '') + '> ' + esc(m) + '</label>';
              }).join('') +
            '</div>' +
            '<div class="pneus-filter-group">' +
              '<p class="pneus-filter-title">Prix max (par pneu)</p>' +
              '<div class="pneus-filter-price-row"><input type="number" min="0" id="pneus-filter-prix" placeholder="Ex. 120" value="' + (filters.prixMax != null ? filters.prixMax : '') + '"> €</div>' +
            '</div>' +
            '<div class="pneus-filter-group">' +
              '<p class="pneus-filter-title">Saison</p>' +
              '<select class="pneus-filter-select" id="pneus-filter-saison">' +
                '<option value="">Toutes</option>' +
                SAISONS.map(function (s) { return '<option value="' + s + '"' + (filters.saison === s ? ' selected' : '') + '>' + s + '</option>'; }).join('') +
              '</select>' +
            '</div>' +
          '</aside>' +
          '<div class="pneus-resultats-main">' +
            '<p class="pneus-resultats-count">' + currentResults.length + ' pneu' + (currentResults.length > 1 ? 's' : '') + ' disponible' + (currentResults.length > 1 ? 's' : '') + '</p>' +
            '<div class="pneus-resultats-grid">' + currentResults.map(renderCard).join('') + '</div>' +
          '</div>' +
        '</div>';

      root.innerHTML = html;
      wireFilters();
      wireCards();
    }

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
